import { render, staticRenderFns } from "./userInfoTop.vue?vue&type=template&id=ca93774a&scoped=true&lang=pug&"
import script from "./userInfoTop.vue?vue&type=script&lang=js&"
export * from "./userInfoTop.vue?vue&type=script&lang=js&"
import style0 from "./userInfoTop.vue?vue&type=style&index=0&id=ca93774a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca93774a",
  null
  
)

export default component.exports